<template>
    <!-- Modal principal pour la facturation POS -->
    <Transition name="modal-fade">
    <div v-if="isdisplay" class="cf-overlay" tabindex="-1">
        <div class="cf-dialog cf-dialog--xxl" :class="isDarkMode ? 'componnentbackground' : ''">

            <!-- Conteneur principal du modal -->
            <div class="w-full mx-auto">

                <!-- Header du modal avec titre et contrôles -->
                <div :class="!isDarkMode ? 'bg-gradient-to-r' : 'componnentbackground'" class="cf-pos-head flex-1  from-blue-500 to-purple-600 text-white p-4 rounded-t-lg">


                    <!-- Titre du modal -->
                    <h6 class="modal-title headertitle text-xl font-bold" id="staticBackdropLabel2">
                        {{ titlemodal }}
                    </h6>

                    <div class="flex items-center gap-3">

                        <p style="color: white" class="text-sm text-gray-600">
                            <span class="font-medium">Date:</span> {{ Items.datedoc }}
                            <template v-if="Items.docnum !== ''"> / {{ Items.docnum }}</template>
                        </p>




                        <!-- Bouton toggle theme sombre/clair -->
                        <div class="header-element header-theme-mode flex items-center py-2 px-3 rounded-lg bg-white/20 hover:bg-white/30 transition-all cursor-pointer"
                             @click="toggleTheme">

                            <!-- Icône lune (mode sombre) -->
                            <a v-show="!isDarkMode"
                               class="flex items-center justify-center text-white hover:text-yellow-300 transition-colors">
                                <i class="bx bx-moon text-lg"></i>
                            </a>

                            <!-- Icône soleil (mode clair) -->
                            <a v-show="isDarkMode"
                               class="flex items-center justify-center text-white hover:text-yellow-300 transition-colors">
                                <i class="bx bx-sun text-lg"></i>
                            </a>
                        </div>

                        <!-- Menu dropdown des actions (menu manuel, charte) -->
                        <div class="cf-pos-dd">
                            <button type="button" @click="showActions5 = !showActions5"
                               class="flex items-center justify-center w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg transition-all">
                                <i class="fe fe-more-vertical text-white"></i>
                            </button>

                            <!-- Liste des actions dans le dropdown -->
                            <transition name="cf-menu-fade">
                            <ul v-show="showActions5" class="cf-pos-menu bg-white shadow-xl rounded-lg border-0">
                                <li>
                                    <a @click="btnupdatefactureselected(); showActions5 = false"
                                       class="cf-pos-item flex items-center gap-2 px-4 py-3 hover:bg-gray-50 transition-colors">
                                        <i class="ri-bill-line text-orange-500"></i>
                                        <span>Factures en attente ({{ nbrefactureenattante }})</span>
                                    </a>
                                </li>

                                <li>
                                    <a @click="handlebtnreinitialiserAllarticle(); showActions5 = false"
                                       class="cf-pos-item flex items-center gap-2 px-4 py-3 hover:bg-gray-50 transition-colors">
                                        <i class="ri-refresh-line text-blue-500"></i>
                                        <span>Synchroniser les articles</span>
                                    </a>
                                </li>

                                <li v-if="isDarkMode">
                                    <a @click="btnmoadalindextransfertdefonddecaisse('APPROC', this.$store.state.typc); showActions5 = false"
                                       class="cf-pos-item flex items-center gap-2 px-4 py-3 hover:bg-gray-50 transition-colors">
                                        <i class="ri-exchange-line text-green-500"></i>
                                        <span>Transfert de fonds</span>
                                    </a>
                                </li>

                                <li>
                                    <a @click="btnmodalpointdelacaisse5(); showActions5 = false"
                                       class="cf-pos-item flex items-center gap-2 px-4 py-3 hover:bg-gray-50 transition-colors">
                                        <i class="ri-pie-chart-line text-purple-500"></i>
                                        <span>Point de la caisse</span>
                                    </a>
                                </li>

                                <li>
                                    <a @click="newinvoice(); showActions5 = false"
                                       class="cf-pos-item flex items-center gap-2 px-4 py-3 hover:bg-gray-50 transition-colors">
                                        <i class="ri-add-line text-indigo-500"></i>
                                        <span>Nouvelle facture</span>
                                    </a>
                                </li>
                            </ul>
                            </transition>
                        </div>
                    </div>

                </div>

                <!-- Corps du modal -->
                <div class="cf-pos-body p-6 bg-gray-50">

                    <!-- Messages de succès et d'erreur -->
                    <div v-if="messagesucces !== ''"
                         class="mb-4 alert alert-success bg-green-100 border border-green-300 text-green-800 px-4 py-3 rounded-lg flex items-center">
                        <i class="ri-check-line text-green-600 mr-2"></i>
                        <div>{{ messagesucces }}</div>
                    </div>

                    <div v-if="messageerror !== ''"
                         class="mb-4 alert alert-danger bg-red-100 border border-red-300 text-red-800 px-4 py-3 rounded-lg flex items-center">
                        <i class="ri-error-warning-line text-red-600 mr-2"></i>
                        <div>{{ messageerror }}</div>
                    </div>

                    <!-- Grille principale en 4 colonnes pour desktop -->
                    <div class="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">

                        <!-- COLONNE 1: Catalogue et liste des articles -->
                        <div class="lg:col-span-1 space-y-4">

                            <!-- Navigation par catégories -->
                            <div class="bg-white rounded-lg shadow-sm border p-4">
                                <h3 class="font-semibold text-gray-800 mb-3">Catégories</h3>
                                <div class="flex flex-wrap gap-2 max-h-32 overflow-y-auto">

                                    <!-- Bouton "Tous" -->
                                    <button @click="selectedcatalogue = ''"
                                            :class="selectedcatalogue === '' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                                            class="px-3 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap">
                                        Tous
                                    </button>

                                    <!-- Boutons pour chaque catégorie -->
                                    <button v-for="(line, index) in datatablearticlegroupe" :key="index"
                                            @click="selectedcatalogue = index"
                                            :class="selectedcatalogue === index ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                                            class="px-3 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap">
                                        {{ index }}
                                    </button>
                                </div>
                            </div>

                            <!-- Contrôles de la liste des articles -->
                            <div class="bg-white rounded-lg shadow-sm border p-4">

                                <!-- Sélecteur de pagination -->
                                <div class="mb-4">
                                    <label class="block text-sm font-medium text-gray-700 mb-2">Articles par page</label>
                                    <select v-model="DefaultperPage"
                                            class="form-control w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="800">800</option>
                                    </select>
                                </div>

                                <!-- Compteur et barre de recherche -->
                                <div class="space-y-3">
                                    <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-600 font-medium">
                      Articles ({{ filterdatatable.length }})
                    </span>
                                    </div>

                                    <div class="relative">
                                        <input v-model="searchword"
                                               ref="modalInput"
                                               class="form-control w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                               type="text"
                                               placeholder="Rechercher un article...">
                                        <i class="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                    </div>
                                </div>

                                <!-- Liste des articles avec scroll -->
                                <div class="mt-4 max-h-96 overflow-y-auto border border-gray-200 rounded-lg">
                                    <ul class="divide-y divide-gray-200">
                                        <li v-for="(datavalue, j) of filterdatatable" :key="j"
                                            @dblclick="selectionitemforfacturation(datavalue)"
                                            @click="selectItem(datavalue)"
                                            :class="[
                          'cursor-pointer transition-colors hover:bg-blue-50',
                          datavalue.pid === selectedItem?.pid ? 'bg-blue-100 border-l-4 border-l-blue-500' : ''
                        ]"
                                            class="p-4">

                                            <div class="flex items-center justify-between">
                                                <!-- Informations de l'article -->
                                                <div class="flex-1 min-w-0">
                                                    <p class="font-semibold text-gray-900 truncate">
                                                        {{ datavalue.libelle }}
                                                    </p>
                                                </div>

                                                <!-- Prix de l'article -->
                                                <div class="ml-3 flex-shrink-0">
                          <span class="inline-flex items-center px-2 py-1 rounded-md text-sm font-bold bg-red-100 text-red-800">
                            {{ !isNormalisationEtat ? formatNumber(datavalue.pu) : formatNumber(datavalue.pu7) }}
                          </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <!-- Pagination -->
                                <div class="mt-4 flex justify-center">
                                    <nav class="flex items-center space-x-2">
                                        <button @click="page--"
                                                :disabled="page <= 1"
                                                :class="page <= 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'"
                                                class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg transition-colors">
                                            Précédent
                                        </button>

                                        <button @click="page++"
                                                :disabled="page >= pages.length"
                                                :class="page >= pages.length ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'"
                                                class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg transition-colors">
                                            Suivant
                                        </button>
                                    </nav>
                                </div>
                            </div>
                        </div>

                        <!-- COLONNE 2-3: Panier/Facture (visible uniquement sur grand écran) -->
                        <div   class="lg:col-span-2">
                            <div class="bg-white rounded-lg shadow-sm border h-auto flex flex-col">

                                <!-- Header du tableau -->
                                <div class="p-4 border-b bg-gray-50 rounded-t-lg">
                                    <h3 class="font-semibold text-gray-800">Articles sélectionnés</h3>
                                </div>

                                <!-- Tableau avec scroll -->
                                <div class="flex-1 overflow-hidden">
                                    <div class="h-full overflow-auto">
                                        <table class="w-full table-bordered">
                                            <!-- En-tête sticky -->
                                            <thead class="sticky top-0 bg-red-300">
                                            <tr>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">État</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider" colspan="2">Désignation</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">P.U.</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">Quantité</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">Remise</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">Montant</th>
                                                <th class="px-4 py-3 text-left text-xs font-medium text-red-900 uppercase tracking-wider">Actions</th>
                                            </tr>
                                            </thead>

                                            <!-- Corps du tableau -->
                                            <tbody class="bg-white divide-y divide-gray-200">
                                            <template v-if="listedatatable.length">
                                                <template v-for="(datavalue, index) in listedatatable" :key="index">
                                                    <tr class="hover:bg-gray-50 transition-colors">

                                                        <!-- État de la ligne -->
                                                        <td class="px-4 py-3 whitespace-nowrap">
                                <span v-if="datavalue.etatline === 1 || datavalue.etatline === '1'"
                                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  <i class="ri-check-line mr-1"></i>OK
                                </span>
                                                            <span v-else-if="datavalue.etatline === 2 || datavalue.etatline === '2' || datavalue.etatline === 4 || datavalue.etatline === '4'"
                                                                  class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  <i class="ri-error-warning-line mr-1"></i>Erreur
                                </span>
                                                            <span v-else
                                                                  class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                  <i class="ri-time-line mr-1"></i>En attente
                                </span>
                                                        </td>

                                                        <!-- Désignation -->
                                                        <td class="px-4 py-3" colspan="2">
                                                            <div class="text-sm text-gray-900">
                                                                <template v-if="datavalue.autredesignation === ''">
                                                                    {{ datavalue.article.libelle }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ datavalue.article.libelle + ' ( ' + datavalue.autredesignation + ' )' }}
                                                                </template>
                                                            </div>
                                                        </td>

                                                        <!-- Prix unitaire, quantité, remise, montant -->
                                                        <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{{ datavalue.pu }}</td>
                                                        <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{{ formatNumber2(datavalue.qtite) }}</td>
                                                        <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{{ datavalue.remise }}</td>
                                                        <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{{ currencyFormatDE(datavalue.calmtntht) }}</td>

                                                        <!-- Actions -->
                                                        <td class="px-4 py-3 whitespace-nowrap text-sm font-medium">
                                                            <div class="flex space-x-2">
                                                                <button @click="btnupdateqteitem(datavalue)"
                                                                        class="inline-flex items-center p-1.5 border border-transparent rounded-md text-blue-600 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
                                                                    <i class="ri-edit-line"></i>
                                                                </button>
                                                                <button @click="deleteItemArticle(datavalue)"
                                                                        class="inline-flex items-center p-1.5 border border-transparent rounded-md text-red-600 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors">
                                                                    <i class="ri-delete-bin-line"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <!-- Ligne d'erreur si nécessaire -->
                                                    <tr v-if="datavalue.etatline === 2">
                                                        <td colspan="8" class="px-4 py-2">
                                                            <div class="bg-red-50 border border-red-200 rounded-md p-3">
                                                                <div class="text-sm text-red-800" v-html="datavalue.linemessage"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>

                                            <!-- Message si aucun article -->
                                            <template v-else>
                                                <tr>
                                                    <td colspan="8" class="px-4 py-8 text-center">
                                                        <div class="text-gray-500">
                                                            <i class="ri-shopping-cart-line text-4xl mb-2"></i>
                                                            <p class="text-lg font-medium">Aucun article sélectionné</p>
                                                            <p class="text-sm">Double-cliquez sur un article pour l'ajouter</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Footer avec totaux (sticky) -->
                                <div v-if="listedatatable.length" class="border-t bg-gray-50 p-4 space-y-2">
                                    <div class="grid grid-cols-2 gap-4 text-sm">
                                        <!-- Montant HT -->
                                        <div class="flex justify-between">
                                            <span class="font-medium text-gray-700">Montant HT:</span>
                                            <span class="font-bold text-gray-900">{{ currencyFormatDE(Items.mtnt.doccalmtnttotalht) }}</span>
                                        </div>

                                        <!-- Remise si applicable -->
                                        <div v-if="parseFloat(Items.mtnt.docmtntremise) > 0" class="flex justify-between">
                                            <span class="font-medium text-gray-700">Remise:</span>
                                            <span class="font-bold text-red-600">{{ currencyFormatDE(Items.mtnt.docmtntremise) }}</span>
                                        </div>

                                        <!-- Net à payer -->
                                        <div class="flex justify-between col-span-2 pt-2 border-t border-gray-300">
                                            <span class="font-bold text-lg text-gray-800">Net à payer:</span>
                                            <span class="font-bold text-xl text-green-600">{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }}</span>
                                        </div>

                                        <!-- Montant reçu -->
                                        <div class="flex justify-between items-center col-span-2">
                                            <label class="font-medium text-gray-700">Montant reçu:</label>
                                            <input v-model="Items.jsonotherdonne.montantrecu"
                                                   type="number"
                                                   min="0"
                                                   class="w-32 px-3 py-2 border border-gray-300 rounded-md text-right focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                        </div>

                                        <!-- Reliquat -->
                                        <div class="flex justify-between col-span-2 pt-2">
                                            <span class="font-bold text-lg text-gray-800">Reliquat:</span>
                                            <span class="font-bold text-xl text-blue-600">{{ reliquat }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- COLONNE 4: Informations client et paramètres -->
                        <div class="lg:col-span-1 space-y-4">

                            <!-- Options de sauvegarde -->
                            <div class="bg-white rounded-lg shadow-sm border p-4">
                                <h3 class="font-semibold text-gray-800 mb-3">Paramètres</h3>
                                <select v-model="conservationdesdonnees"
                                        class="w-full px-3 py-2 bg-red-500 text-white rounded-md focus:ring-2 focus:ring-red-400">
                                    <option :value="true">Conserver les données après comptabilisation</option>
                                    <option :value="false">Ne pas conserver les données après comptabilisation</option>
                                </select>
                            </div>



                            <!-- Informations client -->
                            <div class="bg-white rounded-lg shadow-sm border p-4 space-y-4">
                                <h3 class="font-semibold text-gray-800 mb-3">Informations client</h3>

                                <!-- Sélection du client -->
                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Client</label>
                                    <select @change="handleElementSelectedcltfrs"
                                            v-model="Items.jsonotherdonne.cltfrs"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                        <option :value="null">Sélectionner un client</option>
                                        <option v-for="(datavalue, index) of otherdatatable.beneficiairecl" :key="index"
                                                :value="datavalue">{{ datavalue.name }}</option>
                                    </select>
                                </div>

                                <!-- IFU et Nom du client -->
                                <div class="grid grid-cols-1 gap-3">
                                    <div class="space-y-2">
                                        <label class="block text-sm font-medium text-gray-700">IFU Client</label>
                                        <input v-model="Items.jsonv.ifu"
                                               type="text"
                                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                               placeholder="IFU du client">
                                    </div>

                                    <div class="space-y-2">
                                        <label class="block text-sm font-medium text-gray-700">Nom Client</label>
                                        <input v-model="Items.jsonv.client"
                                               type="text"
                                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                               placeholder="Nom du client">
                                    </div>
                                </div>

                                <!-- Mode de règlement -->
                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Mode de règlement</label>
                                    <select v-model="Items.jsonv.modereglement"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                        <option :value="null">Sélectionner un mode de règlement</option>
                                        <option v-for="(datavalue, index) of otherdatatable.modedereglement" :key="index"
                                                :value="datavalue">{{ datavalue.name }}</option>
                                    </select>
                                </div>

                                <!-- Serveur -->
                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Serveur</label>
                                    <select v-model="Items.jsonv.collaborateur"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                        <option :value="null">Sélectionner un serveur</option>
                                        <option v-for="(datavalue, index) of otherdatatable.collaborateur" :key="index"
                                                :value="datavalue">{{ datavalue.typecollaborateur + ' / ' + datavalue.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Footer avec boutons d'action -->
                <div class="cf-pos-foot p-6 bg-gray-50 border-t"
                     :style="myscreenSize <= 990 ? 'display: contents!important;' : ''">

                    <div class="flex flex-col sm:flex-row gap-3 justify-end">

                        <!-- Bouton Fermer -->

                    </div>

                </div>




                <div class="flex flex-col myti-modal-footer border-t-0 " >
                    <div class="flex items-center flex-wrap overflow-auto">
                        <div class="mb-2 sm:mb-0">
                            <button style=" margin: 3px;" @click="btnmoadalfermercaisse"  type="button" class="ti-btn ti-btn-secondary-full" >
                                <i class="ri-close-circle-fill"></i>  Fermer la caisse
                            </button>
                        </div>
                        <div class="ms-auto">

                            <button @click="close"
                                    type="button"
                                    class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors">
                                <i class="ri-close-fill mr-2"></i>
                                Fermer
                            </button>

                            <!-- Bouton Comptabiliser -->
                            <button @click="saveItems"
                                    :disabled="compteprocess > 0"
                                    :class="compteprocess > 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600'"
                                    class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors">
                                <i class="ri-calculator-fill mr-2"></i>
                                Comptabiliser
                                <template v-if="compteprocess > 0">
                <span class="ml-2 px-2 py-1 bg-white/20 rounded-full text-xs">
                  {{ compteprocess }}
                </span>
                                </template>
                            </button>


                        </div>
                    </div>
                </div>





            </div>
        </div>
    </div>
    </Transition>

    <!-- Modals enfants (gardés tels quels) -->
    <modalviewitemsdetails ref="modalviewitemsdetails"></modalviewitemsdetails>
    <modalmodifierquantite ref="modalmodifierquantite" @updateqteitem="updateqteitem"></modalmodifierquantite>
    <modalfactureenattente ref="modalfactureenattente" @selectedfacture="updatefactureselected"></modalfactureenattente>
    <modalfacturecomptoirepost ref="modalfacturecomptoirepost" @closed="closeimpression"></modalfacturecomptoirepost>
    <modalpointdelacaisse5 ref="modalpointdelacaisse5"></modalpointdelacaisse5>
    <moadalindextransfertdefonddecaisse ref="moadalindextransfertdefonddecaisse"></moadalindextransfertdefonddecaisse>
    <fermerturecaisseouinon ref="fermerturecaisseouinon" ></fermerturecaisseouinon>
</template>

<script>
    import { inject } from 'vue';


    import modalfacturecomptoirepost from "@/components/views/pages/caisse/rapport/modal_facturecomptoirepost";
    import modalpointdelacaisse5 from "@/components/views/pages/caisse/facturation/5/rapport/modal_listedesfacturactionsalacaisse_5";
    import moadalindextransfertdefonddecaisse from "@/components/views/pages/caisse/transfertdefonddecaisse/index";
    const axios =require('axios');

    import modalentetecommande from "@/components/views/pages/caisse/facturation/2/modal_entete";
    import modalmodifierquantite from "@/components/views/pages/caisse/facturation/modal_modifierquantite";
    import modalviewitemsdetails from "@/components/views/pages/caisse/facturation/modal_viewitemsdetails";
    import modalfactureenattente from "@/components/views/pages/caisse/facturation/2/modal_factureenattente";

    import {
        array_search,
        cloneobjet,
        currencyFormatDE,
        FormatNumber,
        groupByKey,
        isset,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import {mapGetters} from "vuex";
    import qrcodetoimage from "qrcode";
    import fermerturecaisseouinon from "@/components/views/pages/caisse/fermerturecaisseouinon";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            ...mapGetters(['listedesarticlespourlacaisse','myscreenSize']),

            disableddoc(){

                return this.Items.docnum ?true:false;
            },




            datatablearticlegroupe(){

                //let mvalue=cloneobjet(this.listedesarticlespourlacaisse);

                this.datatablearticle=cloneobjet(this.listedesarticlespourlacaisse);

                let $groupbycatalogue=groupByKey(this.listedesarticlespourlacaisse,'catalogue');

                //this.datatablearticlegroupe=$groupbycatalogue

                return $groupbycatalogue ;
            },

            nbrefactureenattante(){
                return  this.datatable.length
            },

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=[];

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                /*if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.removeline===parseFloat(t.searchtrierletableau)

                    })

                }*/


                if (this.selectedcatalogue!==''){
                    let t=this;


                    for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {
                        // console.log("index ",index)
                        // Code à exécuter pour chaque entrée
                        // console.log(index, datavalue);

                        if (index.toLowerCase()===this.selectedcatalogue.toLowerCase()){


                            for (let line of datavalue){

                                mvalue.push(line)
                            }


                        }



                    }



                }
                else{

                    for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {



                        for (let line of datavalue){

                            mvalue.push(line)
                        }


                    }


                }


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.libelle.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }


                //return mvalue

                return this.paginate(mvalue) ;
            },

            montant()
            {




                let montancalcul=0;

                if(this.ItemsArticle.article!==null ){


                    if (this.ItemsArticle.qtite!==0 )
                    {

                        montancalcul=parseFloat(this.ItemsArticle.pu)*parseFloat(this.ItemsArticle.qtite);


                    }


                    if (isNaN(this.ItemsArticle.remise)) {
                        this.ItemsArticle.remise=0;
                    }


                    if (this.ItemsArticle.remise!==0 && !isNaN(this.ItemsArticle.remise) )
                    {
                        montancalcul=montancalcul-parseFloat(this.ItemsArticle.remise);
                    }

                }
                else {
                    this.ItemsArticle.pu=0;
                }
                montancalcul= Math.round(montancalcul)
                //this.ItemsArticle.mtnt=montancalcul;

                return montancalcul


            },

            reliquat(){

                return this.calculMonnaie(this.Items.mtnt.docmtnttotalttc,this.Items.jsonotherdonne.montantrecu);
            },




        },
        components: {
            //  modalselectprice,
            // modalaccompagnement,
            modalentetecommande,
            modalmodifierquantite,
            modalfactureenattente,
            modalfacturecomptoirepost,
            modalpointdelacaisse5,
            modalviewitemsdetails,
            moadalindextransfertdefonddecaisse,
            fermerturecaisseouinon,




        },

        data() {
            return {
                conservationdesdonnees: true,
                isDarkMode: true,
                showActions5: false,
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                otherdatatable:{},
                datatablearticle:[],
                /*datatablearticlegroupe:[],*/
                datatiers:[],
                listedatatable:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                compteprocess:0,

                selectedcatalogue:"",


                ItemsArticle:{
                    accompagnement:[],
                    autredesignation:'',
                    mycheckkey:'',
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    calmtntht:0,
                    etatline:0,
                    pid:''





                },
                Items: {},

                isNormalisationEtat:false,

                selectedItem: null,
                showDetails: false,




                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 20,
                Defaultpage: 1,
                DefaultperPage: 20,
                pages: [],
            };
        },
        methods: {

            btnmoadalfermercaisse(){


                this.$refs.fermerturecaisseouinon.show();

            },

            btnmoadalindextransfertdefonddecaisse(typedoc,vtypc){

                let mname

                this.$refs.moadalindextransfertdefonddecaisse.show(mname,typedoc,vtypc);

            },

            btnmodalpointdelacaisse5(){
                /*
                                let titlemodal="POINT DE LA CAISSE",numpidcaisse="",datedouverture=""



                                if (Object.keys(this.$store.state.caisseinfo).length>0){

                                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                                        datedouverture=this.$store.state.caisseinfo.dateouverture

                                }
                                else{


                                    numpidcaisse=this.$store.state.caisseencour,
                                        datedouverture=""


                                }

                                this.$refs.modalpointdelacaisse5.show(numpidcaisse,datedouverture);

                */
                let titlemodal="",numpidcaisse="",datedouverture=""


                if (Object.keys(this.$store.state.caisseinfo).length>0){

                    numpidcaisse=this.$store.state.caisseinfo.cpid,
                        datedouverture=this.$store.state.caisseinfo.dateouverture

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }

                this.$refs.modalpointdelacaisse5.show("POINT DE LA CAISSE",numpidcaisse,datedouverture,'FVC',this.isNormalisationEtat);


            },
            toggleTheme() {

                if (this.listedatatable.length>0) return;



                this.isDarkMode = !this.isDarkMode;
                // Optionnel: vous pouvez aussi émettre un événement ou mettre à jour un store Vuex/Pinia
                // this.$emit('theme-changed', this.isDarkMode);

                // Optionnel: appliquer le theme au document
                /*  if (this.isDarkMode) {
                      document.documentElement.classList.add('dark');
                  } else {
                      document.documentElement.classList.remove('dark');
                  }

                  */

                if (this.isDarkMode){this.isNormalisationEtat=false;this.Items.jsonv.isnormalisationetat=false}
                else{this.isNormalisationEtat=true;this.Items.jsonv.isnormalisationetat=true}


            },

            handleElementSelectedcltfrs() {


                if(this.Items.jsonotherdonne.cltfrs!==null){


                    this.Items.jsonv.client=this.Items.jsonotherdonne.cltfrs.name
                    this.Items.jsonv.ifu=this.Items.jsonotherdonne.cltfrs.ifu

                }else{
                    this.Items.jsonv.client='';
                    this.Items.jsonv.ifu='';

                }




            },

            calculSomme(p1,p2,p3){

                var number=parseFloat(p1)+parseFloat(p2)+parseFloat(p3)
                return currencyFormatDE(number)
            },
            calculMonnaie(p1,p2){
                var number=parseFloat(p2)-parseFloat(p1)

                return currencyFormatDE(number)
            },

            note(){

                let t=this
                if (this.listedatatable.length>0){

                    let items=[];

                    this.listedatatable.forEach(function (line) {
                        if (line.etatline!==2){ items.push(line) }
                    })

                    let tabvalue={
                        numdoc:this.Items.docnum,
                        date:this.Items.datedoc,
                        client:this.Items.jsonv.client,
                        ifu:this.Items.jsonv.ifu,
                        params:'',
                        params4:'',
                        boutique:'',
                        serveur:(this.Items.jsonv.collaborateur!==null)?this.Items.jsonv.collaborateur.name:'',
                        commandetable:(this.Items.jsonv.commandetable!==null)?this.Items.jsonv.commandetable.name:'',
                        vendeur:this.$store.state.appusername,
                        items:items,
                        montantht:this.calculSomme(this.Items.mtnt.docmtnttotalht,this.Items.mtnt.docmtntremise,0),
                        montanttva:0,
                        montantremise:currencyFormatDE(this.Items.mtnt.docmtntremise),
                        montantnetapayer:this.Items.mtnt.docmtnttotalttc,
                        reglement:this.Items.jsonotherdonne.montantrecu,
                        /*montantmonnaie:this.calculMonnaie(this.Items.mtnt.docmtnttotalttc,this.Items.jsonotherdonne.montantrecu),*/
                        montantmonnaie:0,
                        pourcentageprisenecharge:0,
                        docsaisiepar:this.$store.state.appusername,

                        normalise:'',
                        mecefsignature:'',
                        mecefnim:'',
                        mecefcompteur:'',
                        mecefheure:'',
                        mecefqrr:"",
                    }


                    if (t.Items.jsonv && t.Items.jsonv.param){tabvalue.params=t.Items.jsonv.param.name}


                    this.$refs.modalfacturecomptoirepost.show(tabvalue,'note');


                }


            },

            closeimpression(element){


                if (element!=='note' && element==='facture'){

                    this.newinvoice()

                    this.load()

                }

            },

            btnupdatefactureselected(){

                this.$refs.modalfactureenattente.show(this.datatable);

            },

            btnupdateentetecommande(){

                this.$refs.modalentetecommande.show(this.Items,this.otherdatatable);
            },

            btnupdateqteitem(datavalue){

                let mitems=cloneobjet(datavalue);

                //this.$refs.modalmodifierquantite.show(mitems);

                this.$refs.modalmodifierquantite.show(mitems,this.isNormalisationEtat,'update');

            },


            checkmycheckkey($mycheckkey){
                let resvalue={};
                if(this.listedatatable.length !==0){

                    let dataSearch=[];
                    dataSearch = this.listedatatable.filter(function (article) {

                        return  article.mycheckkey ===$mycheckkey
                    });
                    if(dataSearch.length !==0){
                        //resvalue=dataSearch[0];
                        let mvalue=dataSearch[0];


                        resvalue={
                            linekey:mvalue.linekey,
                            etatline:mvalue.etatline,
                            calmtntht:mvalue.calmtntht,
                            accompagnement:mvalue.accompagnement,
                            mycheckkey:mvalue.mycheckkey,
                            article:mvalue.article,
                            qtite:mvalue.qtite,
                            diqte:0,
                            pu:mvalue.ppu,
                            pa:mvalue.pa,
                            mtnt:mvalue.mtnt ,
                            docnumother:"" ,
                            remise:mvalue.remise,
                            //docnum:value.numdoc,
                            autredesignation:mvalue.autredesignation,
                            doctp:mvalue.doctyp,
                            pid:mvalue.pid,
                            docpid:mvalue.docnum,
                            docnum:mvalue.docnum
                        };

                        //console.log(resvalue)


                    }

                }

                return resvalue;

            },

            updateqteitem($datavalue){

                // console.log("$datavalue ***************** ",$datavalue)

                this.ItemsArticle=$datavalue.item
                /*this.ItemsArticle.qtite=$datavalue.newqte
                this.ItemsArticle.mtnt=this.montant;*/
                this.SaveArticle();


            },

            async updatefactureselected($datavalue){

                // console.log("$datavalue ***************** ",$datavalue)

                let value=$datavalue.item

                this.Items=value

                this.isNormalisationEtat=this.Items.jsonv.isnormalisationetat;


                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+value.pid+'/'+this.$store.state.appsociete+'/allline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            //value.alllignedoc=res.data.m;


                            t.Items.jsonotherdonne.montantrecu=0

                            //  console.log("value-Items ********* ",Items)

                            t.ItemsArticle.docnum=value.numdoc;
                            t.Items.docnum=value.numdoc;
                            t.Items.docpid=value.pid;
                            t.ItemsArticle.docnum=value.pid;
                            t.ItemsArticle.docpid=value.pid;
                            t.Items.pid=value.pid;

                            t.listedatatable=res.data.m
                            t.calcullistedatatable();


                            t.Items.jsonotherdonne.mtypprixdevente='prixvente'
                        }
                        else{
                            // t.datatable=[];
                            // t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })



            },

            selectionitemforfacturation($item){

                this.Items.jsonotherdonne.moderglt=this.Items.jsonv.modereglement

                if (this.Items.jsonotherdonne.cltfrs===null ){


                    toastr['error']( 'Veuillez séléctionner un client valide',"<b></b>");
                    return
                }
                else{


                    if (this.Items.jsonv.client===''){
                        this.Items.jsonv.client=this.Items.jsonotherdonne.cltfrs.name
                        this.Items.jsonv.ifu=this.Items.jsonotherdonne.cltfrs.ifu


                    }


                }

                if (this.Items.jsonotherdonne.moderglt===null ){


                    toastr['error']( 'Veuillez séléctionner le mode de réglement',"<b></b>");
                    return
                }

                let $checkprice=0;
                let $dataprice=[];

                /* if ($item.prixpromo!==0){$checkprice++;$dataprice.push($item.prixpromo)}
                 if ($item.pu!==0){$checkprice++;$dataprice.push($item.pu)}
                 if ($item.pu1!==0){$checkprice++;$dataprice.push($item.pu1)}
                 if ($item.pu2!==0){$checkprice++;$dataprice.push($item.pu2)}
                 if ($item.pu3!==0){$checkprice++;$dataprice.push($item.pu3)}
                 if ($item.pu4!==0){$checkprice++;$dataprice.push($item.pu4)}
                 if ($item.pu5!==0){$checkprice++;$dataprice.push($item.pu5)}
                 if ($item.pu6!==0){$checkprice++;$dataprice.push($item.pu6)}
                 if ($item.pu7!==0){$checkprice++;$dataprice.push($item.pu7)}*/

                /*

                if (this.isNormalisationEtat===true){

                     if ($item.pu7!==0){$checkprice++;$dataprice.push($item.pu7)}

                 }
                 else {

                     if ($item.pu!==0){$checkprice++;$dataprice.push($item.pu)}


                 }

                 */


                // let $mycheckkey=$item.pid+'--prix--'+$dataprice[0]+'--accompagnement--'
                let $mycheckkey=$item.pid

                let $reschek=this.checkmycheckkey($mycheckkey)

                if (Object.keys($reschek).length>0){

                    this.ItemsArticle=$reschek
                    /* this.ItemsArticle.qtite++
                     //this.ItemsArticle.article=$item
                     this.gestionPu($dataprice[0])
                     this.ItemsArticle.mtnt=this.montant;*/

                    this.$refs.modalmodifierquantite.show(cloneobjet(this.ItemsArticle),this.isNormalisationEtat,'update');
                }
                else{
                    this.ItemsArticle.mycheckkey=$mycheckkey
                    this.ItemsArticle.qtite=1
                    this.ItemsArticle.article=$item
                    /*this.gestionPu($dataprice[0])
                    this.ItemsArticle.mtnt=this.montant;*/


                    this.$refs.modalmodifierquantite.show(cloneobjet(this.ItemsArticle),this.isNormalisationEtat,'add');
                }


                /*
                                if ($checkprice===1){




                                    if ($item.accompagnement.length>0){

                                        this.$refs.modalaccompagnement.show($item.accompagnement,$item,$checkprice,$dataprice);


                                    }
                                    else{

                                        let $mycheckkey=$item.pid+'--prix--'+$dataprice[0]+'--accompagnement--'

                                        let $reschek=this.checkmycheckkey($mycheckkey)

                                        if (Object.keys($reschek).length>0){

                                            this.ItemsArticle=$reschek
                                            this.ItemsArticle.qtite++
                                            //this.ItemsArticle.article=$item
                                            this.gestionPu($dataprice[0])
                                            this.ItemsArticle.mtnt=this.montant;
                                            this.SaveArticle();

                                        }
                                    else{
                                            this.ItemsArticle.mycheckkey=$item.pid+'--prix--'+$dataprice[0]+'--accompagnement--'
                                            this.ItemsArticle.qtite=1
                                            this.ItemsArticle.article=$item
                                            this.gestionPu($dataprice[0])
                                            this.ItemsArticle.mtnt=this.montant;
                                            this.SaveArticle();


                                        }



                                    }




                                }


                                if ($checkprice>1){


                                    if ($item.accompagnement.length>0){

                                        this.$refs.modalaccompagnement.show($item.accompagnement,$item,$checkprice,$dataprice);


                                    }
                                    else{


                                        this.$refs.modalselectprice.show($dataprice,$item,{});


                                    }



                                }

                */

            },

            gestionPu($puprixvente){



                //***************************** le bon ok ******************************
                if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                    if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                        if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                            // let cal=   parseFloat(this.itemArticle.article.pu)/1.18
                            let cal=   parseFloat($puprixvente)/1.18
                            // let cal=   parseFloat(this.itemArticle.article.pu)/parseFloat(this.itemArticle.article.typttc)
                            let fixedcal=cal.toFixed(8);
                            //this.itemArticle.pu=Math.round(cal)
                            //this.itemArticle.pu=Math.round(fixedcal)
                            this.ItemsArticle.pu=fixedcal
                            //this.itemArticle.pa=this.itemArticle.article.pu
                            this.ItemsArticle.pa=0

                        }
                        else{
                            //let cal=   parseFloat(this.itemArticle.article.pu)*0.18
                            let cal=   parseFloat($puprixvente)*0.18
                            //this.itemArticle.pu=this.itemArticle.article.pu
                            this.ItemsArticle.pu=$puprixvente
                            this.ItemsArticle.pa=Math.round(cal)

                        }



                    }
                    else{

                        this.ItemsArticle.pu=$puprixvente
                        this.ItemsArticle.pa=0
                        /*this.itemArticle.pu=this.itemArticle.article.pu
                        this.itemArticle.pa=this.itemArticle.article.pu*/

                    }


                }
                else{

                    this.ItemsArticle.pu=$puprixvente
                    this.ItemsArticle.pa=0
                    /*this.itemArticle.pu=this.itemArticle.article.pu
                    this.itemArticle.pa=this.itemArticle.article.pu*/


                }

            },

            calcullistedatatable() {

                let vm=this;


                let $montantnontaxable=0,
                    $montantaib=0,
                    $montantcdtionreglemen=0,
                    $montanttva=0,
                    $montanthtarpvht=0,
                    $montanthtarpvttc=0,
                    $montanttotalht=0,
                    $montanttotalttc=0,
                    $montanttotaltrt =0,
                    $smontantremise=0,
                    $istva=0;

                if (this.listedatatable.length>0){

                    this.listedatatable.forEach(function (line) {

                        if (parseFloat(line.etatline)===0 || parseFloat(line.etatline)===1 || parseFloat(line.etatline)===4 ){




                            // $istva=0;
                            let $datajsonarticle=line.article;
                            let $lignemontantht=line.mtnt;
                            let $mtnt_remise=line.remise;

                            if($datajsonarticle.taxedimposition!=="A"){ //verification si l'article est taxable
                                if(vm.Items.jsonotherdonne.appliquetva==="1" || vm.Items.jsonotherdonne.appliquetva===1) /// verification si on applique la tva sur ce document
                                {
                                    //si oui

                                    $istva=1;

                                    if(parseFloat($datajsonarticle.tptva)===1) /// verification de l'application du tva sur cet article
                                    {
                                        //si oui
                                        $montanthtarpvttc=parseFloat($montanthtarpvttc)+parseFloat($lignemontantht);  //montant total des montants HT sur lequelle on applique la tva

                                    }
                                    else{
                                        $montanthtarpvht=parseFloat($montanthtarpvht)+parseFloat($lignemontantht) ;//montant total des montants HT sur lequelle on pas applique la tva

                                    }



                                }
                                else{ // On applique pas la tv a sur le produit


                                    $montanthtarpvttc=0;
                                    $montanthtarpvht=parseFloat($montanthtarpvht)+parseFloat($lignemontantht); //montant total des montants HT sur lequelle on pas applique la tva

                                }

                            }
                            else{

                                $montantnontaxable=parseFloat($montantnontaxable)+parseFloat($lignemontantht) ;

                            }

                            $smontantremise=parseFloat($smontantremise)+parseFloat($mtnt_remise);
                        }
                    })



                    // $montanttotalht= floatval($montanthtarpvttc)+ floatval($montanthtarpvht);/// calcul du montant total ht sans le montant non taxable
                    $montanttotalht= parseFloat($montanthtarpvttc)+ parseFloat($montanthtarpvht)+parseFloat($montantnontaxable);/// calcul du montant total ht avec le montant non taxable

                    $montanttotaltrt="";

                    if ( $istva===1){

                        $montanttva= parseFloat($montanthtarpvttc)*0.18;////// calcul du montant de la TVA

                    }

                    let $aib=parseInt(vm.Items.jsonotherdonne.aib); // taux de AIB


                    let  $libaib="AIB";
                    if ($aib!==0){
                        $libaib="Montant AIB ("+$aib+" %)";

                        $montantaib=parseFloat($montanttotalht)*(parseInt($aib)/100);


                    }else {$montantaib=0;}


                    let $netfinancier=0;


                    if (this.typedoc==="DAF" || this.typedoc==="BCF" ||
                        this.typedoc==="RF" ||  this.typedoc==="FR" ||
                        this.typedoc==="FRF")
                    {
                        $montantaib=-$montantaib;
                        $netfinancier=$montanttotalht+$montantaib;



                        if ( $istva===1){
                            $montanttva= parseFloat($netfinancier)*0.18;////// calcul du montant de la TVA
                        }

                        $montanttotalttc=parseFloat($netfinancier)+parseFloat($montanttva);

                    }
                    else{

                        /////// calcul du montant ttc

                        $montanttotalttc=parseFloat($montanttotalht)+parseFloat($montantaib)+parseFloat($montanttva);


                    }


                    vm.Items.mtnt={
                        doctva:Math.round($montanttva),
                        docmtnttotalttc:Math.round($montanttotalttc),
                        docmtntaib:Math.round($montantaib),
                        docmtntremise:Math.round($smontantremise),
                        docmtnttotalht:Math.round($montanttotalht),
                        doccalmtnttotalht:Math.round($montanttotalht)+Math.round($smontantremise),
                        libaib:$libaib
                    };

                }
                else{
                    this.Items.mtnt={
                        doctva:Math.round(0),
                        docmtnttotalttc:Math.round(0),
                        docmtntaib:Math.round(0),
                        docmtntremise:Math.round(0),
                        docmtnttotalht:Math.round(0),
                        doccalmtnttotalht:Math.round(0),
                        libaib:"Montant AIB (0 %)"
                    }

                }




            },

            newArticle(){
                this. ItemsArticle.docmag=this.mydocmag;
                this. ItemsArticle.article=null;
                this. ItemsArticle.qtite=0;
                this. ItemsArticle.pu=0;
                this. ItemsArticle.remise=0;
                this. ItemsArticle.calmtntht=0;
                this. ItemsArticle.mtnt=0;
                this. ItemsArticle.pid='';
                this.storeqtite=0;
                this. ItemsArticle.autredesignation='';
                this. ItemsArticle.linekey='';
                this. ItemsArticle.etatline=0;
                this.ItemsArticle.spid='';
                this.disabled=false;

            },

            async SaveArticle(){

                this.searchword="";

                if (this.Items.jsonotherdonne.cltfrs===null ){
                    toastr['error']( 'Veuillez séléctionner un client',"<b></b>");
                    return
                }

                if (this.Items.jsonotherdonne.moderglt===null ){
                    toastr['error']( 'Veuillez séléctionner le mode de réglement',"<b></b>");
                    return
                }

                if (this.ItemsArticle.article===null)
                {
                    toastr['error']( 'Veuillez sélectionner un article valide',"<b></b>");
                    return

                }

                if (parseFloat(this.ItemsArticle.qtite)===0 ||
                    parseFloat(this.ItemsArticle.mtnt)===0  ||
                    parseFloat(this.ItemsArticle.pu)===0)
                {
                    toastr['error']( 'Veuillez saisir toutes les informations(la quantité ou le prix)',"<b></b>");
                    return

                }




                let vm=this,
                    linekey="",
                    newqtite=0,
                    $mtnt=0,
                    $remise=0,
                    oldqtite=0,
                    mitems,
                    t=this;


                if (t.ItemsArticle.linekey===""){
                    linekey= randomString(20);
                    t.ItemsArticle.linekey=linekey;
                    t.ItemsArticle.etatline=0
                    t.ItemsArticle.ppu=t.ItemsArticle.pu;
                    //t.ItemsArticle.pu=t.ItemsArticle.pu;
                    t.ItemsArticle.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                    mitems=cloneobjet(t.ItemsArticle);

                    t.listedatatable.push(mitems);

                }
                else{

                    linekey=t.ItemsArticle.linekey;
                    newqtite=t.ItemsArticle.qtite;

                    t.listedatatable.forEach(function (line) {

                        if (line.linekey===linekey){
                            line.etatline=0;
                            oldqtite=line.qtite;
                            line.qtite=newqtite;
                            line.ppu=t.ItemsArticle.pu;
                            line.pu=t.ItemsArticle.pu;
                            line.autredesignation=t.ItemsArticle.autredesignation
                            line.mtnt=t.ItemsArticle.mtnt
                            line.mtntclt=t.ItemsArticle.mtntclt
                            line.remise=t.ItemsArticle.remise
                            line.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                        }
                    })

                    mitems=cloneobjet(t.ItemsArticle);

                }

                t.newArticle();
                t.calcullistedatatable();
                t.compteprocess++; // compte le de process en cour

                mitems.cf=this.$store.state.caisseinfo;



                let url="",donneval={},response;

                if(t.Items.pid!==""){
                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/vline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,mitems,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }
                else{

                    this.$store.dispatch('lancerchargement',true)


                    t.Items.jsonotherdonne.tpdoc="facture"
                    t.Items.jsonotherdonne.tredocument="vente"
                    t.Items.cf=this.$store.state.caisseinfo
                    t.Items.jsonv.modereglement=t.Items.jsonotherdonne.moderglt
                    t.Items.jsonv.typ="VENC"
                    t.Items.jsonv.comptabilise=0

                    donneval={  'itemdoc':t.Items, 'itemArticle':mitems, }

                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/add895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,donneval,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");


                            t.compteprocess--;



                            if(t.Items.pid===""){

                                t.ItemsArticle.docnum=res.data.numdoc;
                                t.Items.docnum=res.data.numdoc;
                                t.Items.docpid=res.data.keypid;
                                t.ItemsArticle.docnum=res.data.keypid;
                                t.ItemsArticle.docpid=res.data.keypid;
                                t.Items.pid=res.data.keypid;

                            }

                            //  if (line.pid===""){line.pid=res.data.key;}

                            let $search=""

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=1;

                                    $search=line.article.pid

                                    if (line.pid===""){

                                        line.pid=res.data.keyline;
                                        line.docnum=res.data.keypid;
                                        line.docpid=res.data.keypid;

                                    }

                                }
                            })

                            let $checkindex=array_search($search,t.datatablearticle,'pid')

                            if ($checkindex>=0){


                                if (parseFloat(t.datatablearticle[$checkindex].instock)===1){
                                    t.datatablearticle[$checkindex].rstck=res.data.pk

                                    t.$store.commit('listedesarticlespourlacaisse', { value:t.datatablearticle });



                                }


                            }





                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                            t.compteprocess--;

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=2;


                                    line.linemessage="Une erreur c'est produite lors du traitement de l'opération." +
                                        " Veuillez réessayer l'opération. "+res.data.message;



                                }

                            })

                            t.calcullistedatatable();



                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");

                        t.compteprocess--;

                        t.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.etatline=2;
                                line.linemessage="Une erreur c'est produite lors du traitement de l'opération.Elle a échoué. Veuillez réessayer l'opération. ";

                            }

                        })

                        t.calcullistedatatable();


                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },

            async deleteItemArticle(ItemsArticle){




                if (ItemsArticle.article===null)
                {

                    toastr['error']( 'Veuillez sélectionner un article valide',"<b></b>");
                    return

                }

                if (parseFloat(ItemsArticle.qtite)===0 ||  parseFloat(ItemsArticle.mtnt)===0  ||  parseFloat(ItemsArticle.pu)===0)
                {

                    toastr['error']( 'Veuillez saisir toutes les informations(la quantité ou le prix)',"<b></b>");
                    return

                }




                ItemsArticle.spid=ItemsArticle.docnum


                const t = this;



                let vm=this,
                    linekey="",
                    newqtite=0,
                    $mtnt=0,
                    $remise=0,
                    oldqtite=0,
                    mitems ;


                if (ItemsArticle.linekey===""){
                    /*linekey= randomString(8);
                    t.ItemsArticle.linekey=linekey;
                    t.ItemsArticle.etatline=0
                    t.ItemsArticle.ppu=(t.typededocument==='vente')?t.ItemsArticle.pu:t.ItemsArticle.pa;
                    t.ItemsArticle.pu=(t.typededocument==='vente')?t.ItemsArticle.pu:t.ItemsArticle.pa;

                    mitems=cloneobjet(t.ItemsArticle);

                    t.listedatatable.push(mitems);*/

                }
                else{

                    linekey=ItemsArticle.linekey;
                    newqtite=ItemsArticle.qtite;

                    t.listedatatable.forEach(function (line) {


                        if (line.linekey===linekey){
                            line.etatline=0;
                            oldqtite=line.qtite;


                        }
                    })

                    mitems=cloneobjet(ItemsArticle);

                }

                if (ItemsArticle.pid===""){ // suppression d'un article non enregistrer dans la base de donnée

                    t.listedatatable.forEach(function (line,index) {

                        if (line.linekey===linekey){

                            t.listedatatable.splice(index,1);
                        }

                    })

                    this.newArticle();
                    this.calcullistedatatable();
                    return
                }


                t.newArticle();
                t.calcullistedatatable();
                t.compteprocess++; // compte le de process en cour

                //this.$store.dispatch('lancerchargement',true)
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/svline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);
                let response =   axios  .post(url,mitems,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        //  t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");
                            let $search=""
                            t.compteprocess--;
                            t.listedatatable.forEach(function (line,index) {

                                if (line.linekey===linekey){

                                    $search=line.article.pid

                                    t.listedatatable.splice(index,1);
                                }
                            })

                            t.calcullistedatatable();

                            let $checkindex=array_search($search,t.datatablearticle,'pid')

                            if ($checkindex>=0){


                                if (parseFloat(t.datatablearticle[$checkindex].instock)===1){
                                    t.datatablearticle[$checkindex].rstck=res.data.pk


                                    t.$store.commit('listedesarticlespourlacaisse', { value:t.datatablearticle });

                                }


                            }





                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                            t.compteprocess--;

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=2;


                                    line.linemessage="Une erreur c'est produite lors du traitement de l'opération." +
                                        " Veuillez réessayer l'opération. "+res.data.message;



                                }

                            })

                            // t.calcullistedatatable();



                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");

                        t.compteprocess--;

                        t.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.etatline=2;
                                line.linemessage="Une erreur c'est produite lors du traitement de l'opération.Elle a échoué. Veuillez réessayer l'opération. ";

                            }

                        })

                        //t.calcullistedatatable();


                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },

            async  saveItems(){

                this.$store.dispatch('lancerchargement',true)

                this.Items.cf=this.$store.state.caisseinfo;


                if(this.$store.state.authorizeprix0 === "false" || this.$store.state.authorizeprix0 === false){


                    if (this.Items.jsonotherdonne.montantrecu===0 || this.Items.jsonotherdonne.montantrecu==='' ){

                        toastr['error']( 'Veuillez saisir le montant reçu pour comptabiliser la vente.',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)

                        return
                    }

                }

                if(this.$store.state.authorizefacturactionpartiel === "false" || this.$store.state.authorizefacturactionpartiel === false){

                    if (this.Items.mtnt.docmtnttotalttc > this.Items.jsonotherdonne.montantrecu ){

                        toastr['error']( 'Le montant reçu est insuffisant, pour comptabiliser la facturation..',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)

                        return
                    }


                }


                let value={
                    'cf':this.$store.state.caisseinfo,
                    'dpid':this.Items.pid,
                    'dmtnt':this.Items.jsonotherdonne.montantrecu,
                    'jsonotherdonne':this.Items.jsonotherdonne,
                    'jsonv':this.Items.jsonv,
                    'document':"FCOMPTOIRE",
                    'item':this.Items,
                    'isNormalisationEtat':this.isNormalisationEtat,
                    'componnent':5,
                }


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/'+this.$store.state.appsociete+'/add895418init51_refdepdpcc11515/'+randomString();
                let response =   axios  .post(url,value,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(async function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");

                            let normalise=0
                            let mecefsignature=""
                            let mecefnim=""
                            let mecefcompteur=""
                            let mecefheure=""
                            let mecefqrr=""
                            let urlimagegenerer=""


                            if (t.$store.state.authorizenormalisation==="true" || t.$store.state.authorizenormalisation===true){
                                mecefsignature=res.data.m.mecef.mecefsignature
                                mecefnim=res.data.m.mecef.mecefnim
                                mecefcompteur=res.data.m.mecef.mecefcompteur
                                mecefheure=res.data.m.mecef.mecefheure
                                mecefqrr=res.data.m.mecef.mecefqrr
                                normalise=res.data.m.mecef.normalise





                                // Générer un QR code sous forme d'URL de données
                                urlimagegenerer = await new Promise((resolve) => {
                                    qrcodetoimage.toDataURL(mecefqrr, { width: 125, margin: 2 }, (err, url) => resolve(err ? "" : url));
                                });

                            }


                            let items=[];

                            t.listedatatable.forEach(function (line) {
                                if (line.etatline!==2){ items.push(line) }
                            })


                            let tabvalue={
                                numdoc:t.Items.docnum,
                                date:t.Items.datedoc,
                                client:t.Items.jsonv.client,
                                ifu:t.Items.jsonv.ifu,
                                params:'',
                                params4:'',
                                boutique:'',
                                serveur:(t.Items.jsonv.collaborateur!==null)?t.Items.jsonv.collaborateur.name:'',
                                commandetable:(t.Items.jsonv.commandetable!==null)?t.Items.jsonv.commandetable.name:'',
                                vendeur:t.$store.state.appusername,
                                items:items,
                                montantht:t.calculSomme(t.Items.mtnt.docmtnttotalht,t.Items.mtnt.docmtntremise,0),
                                montanttva:0,
                                montantremise:t.currencyFormatDE(t.Items.mtnt.docmtntremise),
                                montantnetapayer:t.currencyFormatDE(t.Items.mtnt.docmtnttotalttc),
                                reglement:t.currencyFormatDE(t.Items.jsonotherdonne.montantrecu),
                                montantmonnaie:t.calculMonnaie(t.Items.mtnt.docmtnttotalttc,t.Items.jsonotherdonne.montantrecu),
                                pourcentageprisenecharge:0,
                                docsaisiepar:t.$store.state.appusername,


                                normalise:normalise,
                                mecefsignature:mecefsignature,
                                mecefnim:mecefnim,
                                mecefcompteur:mecefcompteur,
                                mecefheure:mecefheure,
                                mecefqrr:urlimagegenerer,

                            }

                            if (t.Items.jsonv && t.Items.jsonv.param){tabvalue.params=t.Items.jsonv.param.name}

                            t.$refs.modalfacturecomptoirepost.show(tabvalue,'facture');




                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");

                            this.isdisplay=false;

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))

            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

            formatNumber2(p1){
                var number=Number(p1)
                return FormatNumber(number)
            },

            formatNumber(num) {

                return  currencyFormatDE(num)
            },


            closeform(value){

                this.datatablearticle=value
                this.load();

            },

            async loadline(value){

                ///m/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/:pidcaisse/:keyuser/add895418init51comptoirerefdepdpcc11515/:ftoken

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+value.pid+'/'+this.$store.state.appsociete+'/allline895418init51comptoirerefdepdpcc11515/'+randomString(280);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            value.alllignedoc=res.data.m;


                            let mname='Facturation au comptoir';


                            t.$refs.modalform.show(mname,"update",value,t.datatablearticle,t.otherdatatable);


                        }
                        else{
                            t.datatable=[];
                            t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            async load(){

                var caisse={
                    cf:this.$store.state.caisseinfo,
                    document:"FV",
                }

                ///m/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/:pidcaisse/:keyuser/add895418init51comptoirerefdepdpcc11515/:ftoken

                // this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/load895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);
                let response =   axios  .post(url,caisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){

                            t.datatable=[];
                            t.datatable=res.data.m;

                        }
                        else{
                            t.datatable=[];


                        }


                    })
                    .catch((error)=>{

                            //  t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        // t.$store.dispatch('lancerchargement',false)


                    })




            },

            async loadreturnotherdata(){

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){
                            t.otherdatatable=[];
                            t.otherdatatable=res.data.otherdata;
                        }
                        else{
                            t.otherdatatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                //  }



            },

            async loadinputlibelleforms(){



                let $VALUEDATAPRICE=JwtService.getVALUEDATAPRICE()

                if (isset($VALUEDATAPRICE)){

                    this.datainputlibelleforms=JSON.parse($VALUEDATAPRICE);


                }
                else{
                    const t = this;
                    let url=process.env.VUE_APP_API_URL+'/12478855libelinputindex2iofdofiloadexp2/'+this.$store.state.appsociete+'/'+randomString();
                    let response =   axios  .get(url,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                    let res= await response
                        .then(function (res){
                            t.$store.dispatch('lancerchargement',false)


                            if(res.data.success){


                                t.datainputlibelleforms=[];

                                t.datainputlibelleforms=res.data.valuedataprice;

                                JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))


                            }
                            else{
                                t.datainputlibelleforms=[];

                            }


                        })
                        .catch((error)=>{

                                t.$store.dispatch('lancerchargement',false)
                            }
                        )
                        .finally(() =>{

                            t.$store.dispatch('lancerchargement',false)


                        })
                }



            },

            btnimprimer(value){

                let t=this

                if (t.typedoc==='DPCC' || t.typedoc==='REF'){
                    value.alldepense.push({motif:value.motif, montant:value.montant});
                }


                let tabvalue={
                    nbon:value.nbon,
                    numdoc:value.numdoc,
                    date:value.dateop,
                    montanttotal:value.montant,
                    montanttotaldelafacure:value.montant,
                    items:value.alldepense,
                    docsaisiepar:value.saisirpar,
                    benrficiaire:value.beneficiaire,
                    qrr:value.docnum,
                    patient:value.beneficiaire.name,
                    observations:value.motif,
                    typdoc:t.typedoc


                }



                this.$refs.modalrapportdeprefdpcc.show(tabvalue);


            },



            close(){
                window.removeEventListener('keydown', this.handleKeydown)
                this.isdisplay=false;

                this.$emit('closed',this.datatablearticle);

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },



            Misecommandeenattente(){

                this.listedatatable=[];
                this.ItemsArticle={
                    accompagnement:[],
                    autredesignation:'',
                    mycheckkey:'',
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    calmtntht:0,
                    etatline:0,
                    pid:''
                }
                this.Items= {
                    pid:'',
                    mag:null,
                    datedoc:this.$store.state.dateouverturecaisse,
                    docobservation:'',
                    docnum:'',
                    docnumother:'',
                    docpid:0,
                    doctyp:'',
                    infodoc:{
                        infolibre:'',
                        infolibre1:'',
                        infolibre2:'',
                        infolibre3:'',
                    },
                    jsonotherdonne:{
                        montantrecu:0,
                        tpdoc:"",
                        tredocument:"",
                        mtypprixdevente:"prixvente",
                        magvers:null,
                        collaborateur:null,
                        commandetable:null,
                        cltfrs:null,
                        moderglt:null,
                        cdtreglement:null,
                        appliquetva:0,
                        aib:0,
                        adresseexpedition:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },
                        infodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },



                    },
                    mtnt:{
                        montanthtassurance: 0,
                        docmtntaib: 0,
                        docmtntremise: 0,
                        docmtnttotalht: 0,
                        docmtnttotalttc: 0,
                        doctva: 0,
                        libaib: "AIB"


                    },
                    params:{
                        param1:null,
                        param2:null,
                        param3:null,
                        param4:null,
                    },
                    jsondoc:{},
                    jsonv:{

                        ifu:'',
                        client:'',
                        collaborateur:null,
                        modereglement:null,
                        commandetable:null,
                        indicateur:'',
                        indicateur1:'',
                        param:null,
                        param1:null,


                    }
                }

                toastr['success']( "La commande a été correctement mise en attente","<b></b>");




            },



            newinvoice(){

                this.listedatatable=[];
                this.ItemsArticle={
                    accompagnement:[],
                    autredesignation:'',
                    mycheckkey:'',
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    calmtntht:0,
                    etatline:0,
                    pid:''
                }


                if (this.conservationdesdonnees===false){

                    this.Items= {
                        pid:'',
                        mag:null,
                        datedoc:this.$store.state.dateouverturecaisse,
                        docobservation:'',
                        docnum:'',
                        docnumother:'',
                        docpid:0,
                        doctyp:'',
                        infodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },
                        jsonotherdonne:{
                            montantrecu:0,
                            tpdoc:"",
                            tredocument:"",
                            mtypprixdevente:"prixvente",
                            magvers:null,
                            collaborateur:null,
                            commandetable:null,
                            cltfrs:null,
                            moderglt:null,
                            cdtreglement:null,
                            appliquetva:0,
                            aib:0,
                            adresseexpedition:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },
                            infodoc:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },



                        },
                        mtnt:{
                            montanthtassurance: 0,
                            docmtntaib: 0,
                            docmtntremise: 0,
                            docmtnttotalht: 0,
                            docmtnttotalttc: 0,
                            doctva: 0,
                            libaib: "AIB"


                        },
                        params:{
                            param1:null,
                            param2:null,
                            param3:null,
                            param4:null,
                        },
                        jsondoc:{},
                        jsonv:{

                            ifu:'',
                            client:'',
                            collaborateur:null,
                            modereglement:null,
                            commandetable:null,
                            indicateur:'',
                            indicateur1:'',
                            param:null,
                            param1:null,
                            isnormalisationetat:this.isNormalisationEtat


                        }
                    }

                }else{

                    this.Items= {
                        pid:'',
                        mag:null,
                        datedoc:this.$store.state.dateouverturecaisse,
                        docobservation:'',
                        docnum:'',
                        docnumother:'',
                        docpid:0,
                        doctyp:'',
                        infodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },
                        jsonotherdonne:{
                            montantrecu:0,
                            tpdoc:"",
                            tredocument:"",
                            mtypprixdevente:"prixvente",
                            magvers:null,
                            collaborateur:null,
                            commandetable:null,
                            cltfrs:this.Items.jsonotherdonne.cltfrs,
                            moderglt:null,
                            cdtreglement:null,
                            appliquetva:0,
                            aib:0,
                            adresseexpedition:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },
                            infodoc:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },

                        },
                        mtnt:{
                            montanthtassurance: 0,
                            docmtntaib: 0,
                            docmtntremise: 0,
                            docmtnttotalht: 0,
                            docmtnttotalttc: 0,
                            doctva: 0,
                            libaib: "AIB"


                        },
                        params:{
                            param1:null,
                            param2:null,
                            param3:null,
                            param4:null,
                        },
                        jsondoc:{},
                        jsonv:{

                            ifu:this.Items.jsonv.ifu,
                            client:this.Items.jsonv.client,
                            collaborateur:this.Items.jsonv.collaborateur,
                            modereglement:this.Items.jsonv.modereglement,
                            commandetable:this.Items.jsonv.commandetable,
                            indicateur:'',
                            indicateur1:'',
                            param:null,
                            param1:null,
                            isnormalisationetat:this.isNormalisationEtat

                        }
                    }

                }





            },


            show(datatablearticle){


                if(this.$store.state.caisseencour==='' ||
                    this.$store.state.caisseencour===''){

                    toastr['error']( "Veuillez sélectionner une caisse valide.")
                    this.$router.push({ name: 'tcaisse' });
                }
                else{


                    this.messagesucces="";
                    this.messageerror="";
                    //this.datatablearticle=datatablearticle;
                    this.titlemodal="Liste des facturations"



                    /*

                    let $groupbycatalogue=groupByKey(this.datatablearticle,'catalogue');

                    this.datatablearticlegroupe=$groupbycatalogue

                    */

                    this.selectedItem= null
                    this.showDetails= false

                    this.Items= {
                        pid:'',
                        mag:null,
                        datedoc:this.$store.state.dateouverturecaisse,
                        docobservation:'',
                        docnum:'',
                        docnumother:'',
                        docpid:0,
                        doctyp:'',
                        infodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },
                        jsonotherdonne:{
                            montantrecu:0,
                            tpdoc:"",
                            tredocument:"",
                            mtypprixdevente:"prixvente",
                            magvers:null,
                            collaborateur:null,
                            commandetable:null,
                            cltfrs:null,
                            moderglt:null,
                            cdtreglement:null,
                            appliquetva:0,
                            aib:0,
                            adresseexpedition:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },
                            infodoc:{
                                infolibre:'',
                                infolibre1:'',
                                infolibre2:'',
                                infolibre3:'',
                            },



                        },
                        mtnt:{
                            montanthtassurance: 0,
                            docmtntaib: 0,
                            docmtntremise: 0,
                            docmtnttotalht: 0,
                            docmtnttotalttc: 0,
                            doctva: 0,
                            libaib: "AIB"


                        },
                        params:{
                            param1:null,
                            param2:null,
                            param3:null,
                            param4:null,
                        },
                        jsondoc:{},
                        jsonv:{

                            ifu:'',
                            client:'',
                            collaborateur:null,
                            modereglement:null,
                            commandetable:null,
                            indicateur:'',
                            indicateur1:'',
                            param:null,
                            param1:null,
                            isnormalisationetat:false,


                        }
                    }

                    this.loadinputlibelleforms();
                    this.loadreturnotherdata();
                    this.load();
                    window.addEventListener('keydown', this.handleKeydown)
                    this.isdisplay=true;




                }

            },

            selectItem(item) {
                this.selectedItem = item
                this.showDetails = false
            },
            handleKeydown(event) {
                if (event.code === 'F1') {
                    event.preventDefault()
                    if (this.selectedItem && this.isDarkMode) {
                        //  console.log('un element selected.')
                        // console.log('this.selectedItem 1 ***** ',this.selectedItem)
                        //this.showDetails = true

                        this.$refs.modalviewitemsdetails.show(this.selectedItem);


                    } else {
                        // console.log('Aucun article sélectionné.')
                    }
                }

                //console.log('Touche pressée:', event.code);
            },


            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },

        setup(props) {
            // Injecter la méthode 'addCompte' provenant du parent
            const btnreinitialiserAllarticle = inject('reinitialiserAllarticle');




            const handlebtnreinitialiserAllarticle = () => {

                // Appel de la méthode injectée
                if (btnreinitialiserAllarticle) {
                    btnreinitialiserAllarticle();
                }

            };



            return {
                handlebtnreinitialiserAllarticle,

            };
        },




        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
    /* Charte cf-/ds- : enveloppe (le contenu POS gère son dark mode via .componnentbackground) */
    .cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:flex-start; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); overflow:auto; }
    .cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); overflow:hidden; margin:auto; }
    .cf-dialog--xxl { max-width:1200px; }
    .cf-pos-head { display:flex; align-items:center; justify-content:space-between; gap:1rem; flex-wrap:wrap; }
    .cf-pos-body { overflow-y:auto; }
    .cf-pos-dd { position:relative; }
    .cf-pos-menu { position:absolute; right:0; top:calc(100% + 6px); z-index:50; min-width:280px; list-style:none; margin:0; padding:0.35rem; }
    .cf-pos-item { cursor:pointer; border-radius:var(--cf-radius-sm); color:var(--cf-ink); }
    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition:opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity:0; transform:translateY(-4px); }
    .modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
    .modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }

    .componnentbackground{
        background-color: darkgray;
    }


    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .h-screen550{

        height: 550px!important;

    }

    .h-screen600{

        height: 600px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    .mybodyheight700px{
        height: 700px;
    }






    ::-webkit-scrollbar {
        height: 15px!important;

    }

    .activebtn {
        color: white;
        background-color: #00d1b2;
    }


    .hoveritemsarticle:hover {
        color: white;
        background-color: #00d1b2;
        border-radius: 20px;
    }


    .selectedItems {
        color: white;
        background-color: #00d1b2;
        border-radius: 20px;
    }



    @media screen and (max-width: 768px) {

        .cf-dialog--xxl{
            max-width: 100%!important;
        }


        .h-screen550,.h-screen600,.h-screen,.mybodyheight700px,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>